import React from 'react'

import { useChangeSearch, useSearch } from '@btime/react-contexts'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../components/helpers/Separator'

const SearchBar = () => {
  const changeSearch = useChangeSearch()
  const search = useSearch()

  return (
    <>
      <Separator weight={4} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol flex={1}>
          <SearchInput value={search} onStopTyping={changeSearch} />
        </FlexCol>
      </FlexGrid>
      <Separator weight={4} />
    </>
  )
}

export default SearchBar
